<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="@/assets/paynec/Group 1340@2x (1).png" style="width: 16px; height: 16px" />
				<div class="cement">我的佣金</div>
				<div class="positioning">
					<img src="@/assets/paynec/Rectangle 314@2x.png" style="width: 160px; height: 32px" />
					<div class="settlement">累积结算佣金{{ numPretty(userInfo.proxyAmount) }}</div>
				</div>
			</div>
			<div class="border-top"></div>
			<div class="flex-date-type">
				<div class="cash-amount">
					<div class="cash-title">提现金额</div>
					<div class="cash-price">
						¥
						<span style="font-size: 34px; font-weight: 600">{{ userInfo.amount }}</span>
					</div>
					<div class="withdrawal1" @click="Jump">提现</div>
				</div>

				<div style="margin-left: 40px; width: calc(90% - 40px)">
					<div class="flex-right-paynces">
						<div class="flex-rightTap">
							<div class="flex-rightTap1" @click="disClic(1)">
								<div class="all-title" :class="{ 'all-title1': ids == 1 }">昨日</div>
								<div class="border-top4" v-if="ids == 1"></div>
								<div class="border-top3" v-else></div>
							</div>
							<div class="flex-rightTap1" @click="disClic(2)">
								<div class="all-title" :class="{ 'all-title1': ids == 2 }">本月</div>
								<div class="border-top4" v-if="ids == 2"></div>
								<div class="border-top3" v-else></div>
							</div>
							<div class="flex-rightTap1" @click="disClic(3)">
								<div class="all-title" :class="{ 'all-title1': ids == 3 }">上月</div>
								<div class="border-top4" v-if="ids == 3"></div>
								<div class="border-top3" v-else></div>
							</div>
							<div class="flex-rightTap1" @click="disClic(4)">
								<div class="all-title" :class="{ 'all-title1': ids == 4 }">全部</div>
								<div class="border-top4" v-if="ids == 4"></div>
								<div class="border-top3" v-else></div>
							</div>
						</div>
					</div>
					<div class="border-top" style="margin: 0; padding: 0"></div>
					<div class="Orders-pending">
						<div>
							<div class="order-number">{{ reportData.waitOrderAmount || 0 }}</div>
							<div class="order-title">待结算佣金</div>
						</div>
						<div class="border-taops"></div>
						<div>
							<div class="order-number" style="color: #ff2f17">
								<span style="font-size: 12px">￥</span>
								{{ reportData.waitOrderCount || 0 }}
							</div>
							<div class="order-title">待结算订单</div>
						</div>
						<div class="border-taops"></div>
						<div>
							<div class="order-number">{{ reportData.successOrderCount || 0 }}</div>
							<div class="order-title">已结算订单</div>
						</div>
						<div class="border-taops"></div>
						<div>
							<div class="order-number" style="color: #ff2f17">
								<span style="font-size: 12px">￥</span>
								{{ reportData.successOrderAmount || 0 }}
							</div>
							<div class="order-title">已结算佣金</div>
						</div>
					</div>
				</div>
			</div>
			<el-table :data="dataList" height="450" style="width: 100%; margin-top: 32px">
				<el-table-column prop="orderNo" label="订单号" />
				<el-table-column prop="name" label="卡种" />
				<el-table-column prop="sourcePrice" label="提交面值" />
				<el-table-column prop="realAmount" label="实际面值" />
				<el-table-column prop="userName" label="用户" />
				<el-table-column prop="createTime" label="时间" />
				<el-table-column prop="address" label="状态">
					<template #default="scope">
						{{ scope.row.proxyAmountType === 0 ? '待结算' : '已结算' }}
					</template>
				</el-table-column>
			</el-table>

			<!-- <div style="display: flex; align-items: center; justify-content: space-between">
				<div class="pagination-contact">
					<el-pagination background layout="total, prev, pager, next,jumper" :total="0" />
				</div>
			</div> -->
		</div>
	</div>
</template>

<script setup>
import BigNumber from 'bignumber.js';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getProxyOrderList, getProxyReport } from '@/utils/api.js';
let dataList = ref([]);
let userInfo = ref({});
let reportData = ref({});
let router = useRouter();
let emit = defineEmits(['clickPush']);
let ids = ref(4);

const Jump = () =>{
	// router.push({
	// 	path: '/login'
	// });
	emit('clickPush' , 7);
}

const info = async () => {
	let dateType = '';
	if (ids.value == 1) {
		dateType = 'yesterday';
	} else if (ids.value == 2) {
		dateType = 'month';
	} else if (ids.value == 3) {
		dateType = 'lastMonth';
	}
	let ref = await getProxyOrderList({
		status: 1,
		dateType: dateType,
		proxyAmountType: ''
	});
	dataList.value = ref.data;
};

async function getReport() {
	let { code, data } = await getProxyReport({});
	if (code !== 0) {
		return;
	}
	reportData.value = data;
}

const disClic = (item) => {
	ids.value = item;
	info();
};

onMounted(() => {
	info();
	getReport();
	userInfo.value = JSON.parse(localStorage.getItem('information'));
});

const numPretty = (num) => {
	if (!num) {
		return '￥0.00';
	}
	let tmp = new BigNumber(num);
	if (tmp.isNaN()) {
		return '￥0.00';
	}
	return '￥' + tmp.toFixed(2);
};
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.flex-more {
	display: flex;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-group1 {
	margin-top: 80px;
}
.title-tots {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.assets-vector {
	width: 94%;
	background: #fff5f5;
	border-radius: 7px;
	margin: auto;
	margin-top: 70px;
}
.asset-paingd {
	padding: 16px 12px;
	display: flex;
	align-items: center;
}

.title-asset {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #db8a8a;
	font-style: normal;
	text-transform: none;
	margin-left: 8px;
}

.positioning {
	position: relative;
	margin-left: 11px;
}
.settlement {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff2f17;
	font-style: normal;
	text-transform: none;
	position: absolute;
	top: 6px;
	left: 16px;
}

.cash-amount {
}
.cash-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.cash-price {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ec3925;
	font-style: normal;
	text-transform: none;
	margin-top: 10px;
}
.withdrawal1 {
	width: 139px;
	height: 42px;
	background: #ff2f17;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 9px;
}

.withdrawal1:hover{
	cursor: pointer;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.flex-rightTap1:hover{
	cursor: pointer;
}

.all-title1 {
	color: #ec3925;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.flex-date-type {
	display: flex;
}

.Orders-pending {
	margin-top: 32px;
	margin-left: 12px;
	display: flex;
	align-items: flex-end;
}
.order-number {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 24px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.order-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.border-taops {
	width: 1px;
	height: 18px;
	border-left: 1px solid #eeeeee;
	padding-right: 43px;
	margin-left: 43px;
}
</style>
